import { VdpCardType } from '~/constants/home/VdpCardType';
import { VDPLinkTitles } from '~/constants/home/VdpLinkTitles';

export default function getLinkCardType(header: VDPLinkTitles): VdpCardType {
  switch (header) {
    case VDPLinkTitles.Favorite:
      return VdpCardType.Favorite;
    case VDPLinkTitles.Recent:
      return VdpCardType.Recent;
    default:
      return VdpCardType.Suggested;
  }
}
